// SendGrid forwards inbound mail at two distinct domains depending on the
// environment: prod uses `ingest.dgpt.io`, every non-prod environment (dev,
// staging) uses `dev-ingest.dgpt.io`. The displayed workspace email and any
// downstream copy must follow the same split or QA on dev/staging never
// receives the messages they send.
//
// Vite's MODE is set deterministically by the build scripts (`build:dev`
// → "dev", `build:staging` → "staging", `build:production` → "production")
// so it is the reliable signal here. SERVER_TARGET is not consistently
// passed to CI builds.
export const INBOX_EMAIL_DOMAIN =
  import.meta.env.MODE === "production" ? "ingest.dgpt.io" : "dev-ingest.dgpt.io";
